@if (operadora$ | async; as operadora) { @for (group of menuGroups; track group)
{ @if (!group.invisible) {
<div
  class="layout-inline-menu"
  [ngStyle]="style"
  [class]="styleClass"
  [ngClass]="{
    'layout-inline-menu-active': appMain.inlineMenuActive[group.key],
    'menu-group-active': activeGroupKey === group.key,
    'fixed-active': fixedFlyoutGroup === group.key || hoveredGroup === group.key
  }"
  (mouseenter)="onMouseEnterGroup(group.key)"
  (mouseleave)="onMouseLeaveGroup()"
>
  <a
    class="layout-inline-menu-action flex flex-row align-items-center"
    [ngClass]="appMain.isHorizontal() ? 'p-3 lg:col-1 py-3' : 'p-3'"
    [href]="getGroupHref(group, operadora)"
    pTooltip="{{ group.label }}"
    [tooltipDisabled]="isTooltipDisabled"
    (click)="onGroupActionClick($event, group, operadora)"
  >
    <span class="flex items-center gap-2">
      <i [class]="group.icon"></i>
      @if (!isCompact) {
      <span class="menu-text">{{ group.label }}</span>
      }
    </span>
    @if (group.key === 'pesquisar' && !isCompact) {
    <span class="search-shortcut-hint ml-auto">
      <kbd>Ctrl</kbd><span class="shortcut-separator">+</span><kbd>K</kbd>
    </span>
    } @if ( !isCompact && group.items.length > 1 && group.key !== 'dashboard' )
    {
    <i
      class="pi pi-angle-right layout-inline-menu-icon ml-auto"
      [ngClass]="{
        rotated: hoveredGroup === group.key || fixedFlyoutGroup === group.key
      }"
    ></i>
    }
  </a>
  @if ((hoveredGroup === group.key || fixedFlyoutGroup === group.key) &&
  group.items.length > 1) {
  <ul class="menu-flyout">
    @for (item of group.items; track item) { @if (!item.invisible &&
    !item.locked) {
    <li
      class="layout-inline-menu-action-item"
      pTooltip="{{ item.label }}"
      [tooltipDisabled]="isTooltipDisabled"
    >
      <a
        class="flex flex-row align-items-center"
        [href]="getItemHref(item, operadora)"
        (click)="onMenuItemClick($event, item, operadora)"
      >
        <i [class]="item.icon + ' pi-fw mr-2'"></i>
        <span>{{ item.label }}</span>
      </a>
    </li>
    } @if (!item.invisible && item.locked) {
    <li class="layout-inline-menu-action-item menu-item-locked">
      <a
        class="flex flex-row align-items-center menu-item-locked-link"
        [href]="getItemHref(item, operadora)"
        (click)="onLockedItemClick($event, item, operadora, lockedPanel)"
      >
        <i [class]="item.icon + ' pi-fw mr-2'"></i>
        <span>{{ item.label }}</span>
        <i
          class="pi pi-lock ml-auto menu-lock-icon"
          (click)="$event.stopPropagation(); lockedPanel.toggle($event)"
        ></i>
      </a>
      <p-popover
        #lockedPanel
        [dismissable]="true"
        styleClass="locked-menu-overlay"
        appendTo="target"
      >
        <ng-template pTemplate="content">
          <bl-locked-tooltip
            [allowedModules]="item.lockedModules || []"
          ></bl-locked-tooltip>
        </ng-template>
      </p-popover>
    </li>
    } }
  </ul>
  }
</div>
} }
<p-dialog
  [(visible)]="searchDialogVisible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [showHeader]="false"
  [dismissableMask]="true"
  [closeOnEscape]="true"
  [appendTo]="'body'"
  [baseZIndex]="11000"
  position="top"
  [style]="searchDialogStyle"
  [contentStyle]="searchDialogContentStyle"
  [styleClass]="
    hasSearchTerm
      ? 'global-search-dialog-raw expanded'
      : 'global-search-dialog-raw compact'
  "
  (onHide)="closeSearchDialog()"
  (onShow)="onSearchDialogShow()"
>
  <div #searchShell class="raw-search-shell" [class.expanded]="hasSearchTerm">
    <div class="raw-search-header">
      <div class="raw-search-input-wrap">
        <i class="pi pi-search raw-search-icon"></i>
        <input
          #searchInput
          pInputText
          type="text"
          [ngModel]="searchTerm"
          (ngModelChange)="onSearchTermInput($event)"
          placeholder="Pesquise por uma tela"
          class="raw-search-input"
          autocomplete="off"
        />
        <button
          type="button"
          class="raw-close-button"
          (click)="closeSearchDialog()"
          aria-label="Fechar busca"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>
    @if (shouldShowSearchResults) {
    <div class="raw-search-body">
      @if (filteredSearchItems.length) {
      <div class="raw-search-label">Resultados</div>
      }
      <div class="raw-search-results">
        @for (item of filteredSearchItems; track trackBySearchItem(i, item); let
        i = $index) {
        <div
          #searchResultItem
          class="raw-search-item"
          [class.active]="highlightedSearchIndex === i"
          [class.locked]="item.locked"
          [class.search-item-disabled]="item.locked"
          (click)="onSearchResultClick($event, item, searchLockedPanel)"
          role="button"
          tabindex="0"
          (keydown.enter)="onSearchResultClick($event, item, searchLockedPanel)"
          (keydown.space)="onSearchResultClick($event, item, searchLockedPanel)"
        >
          <div class="raw-search-item-left">
            <div class="raw-search-item-icon">
              <i [class]="item.icon"></i>
            </div>
            <div class="raw-search-item-text">
              <div class="raw-search-item-title">
                {{ item.label }}
              </div>
              <div class="raw-search-item-meta">
                {{
                  item.parentLabel
                    ? item.groupLabel + ' • ' + item.parentLabel
                    : item.groupLabel
                }}
              </div>
            </div>
          </div>
          <div class="raw-search-item-action">
            @if (item.locked) {
            <button
              type="button"
              class="raw-search-lock-button"
              (click)="onSearchLockClick($event, item, searchLockedPanel)"
              aria-label="Ver módulos necessários"
            >
              <i class="pi pi-lock"></i>
            </button>
            } @if (!item.locked) {
            <i class="pi pi-arrow-right"></i>
            }
          </div>
        </div>
        } @if (!filteredSearchItems.length) {
        <div class="raw-search-empty">
          <div class="raw-search-empty-icon">
            <i class="pi pi-search"></i>
          </div>
          <div class="raw-search-empty-title">Nenhuma tela encontrada</div>
          <div class="raw-search-empty-text">
            Parece que não há resultados para sua pesquisa.
          </div>
        </div>
        }
      </div>
      <p-popover
        #searchLockedPanel
        [dismissable]="true"
        styleClass="locked-menu-overlay"
        appendTo="body"
        (onHide)="onSearchLockedOverlayHide()"
      >
        <ng-template pTemplate="content">
          <bl-locked-tooltip
            [allowedModules]="selectedLockedSearchItem?.lockedModules || []"
          ></bl-locked-tooltip>
        </ng-template>
      </p-popover>
    </div>
    }
  </div>
</p-dialog>
}
